import { createContext, useContext } from 'react';

export interface ToastContextProps {
    showToast: (severity: 'success' | 'info' | 'warn' | 'error', summary: string, detail?: string) => void;
    handleToastError: (error: unknown) => void;
}

export const ToastContext = createContext<ToastContextProps | undefined>(undefined);

export const useToast = (): ToastContextProps => {
    const context = useContext(ToastContext);
    if (context === undefined) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};
